var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "hour-range-filter" },
    [
      !_vm.hideLabel
        ? _c("div", { staticClass: "caption grey--text mb-1" }, [
            _vm._v(_vm._s(_vm.label)),
          ])
        : _vm._e(),
      _c("v-autocomplete", {
        attrs: {
          value: _vm.value,
          items: _vm.items,
          loading: _vm.loading,
          disabled: _vm.disabled || (!_vm.loading && !_vm.hasOptions),
          placeholder: _vm.effectivePlaceholder,
          "no-data-text": _vm.emptyText,
          "item-text": "label",
          "item-value": "id",
          outlined: "",
          dense: _vm.dense,
          "hide-details": "",
          clearable: "",
        },
        on: { input: _vm.onInput },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function ({ item }) {
              return [
                item.header
                  ? [
                      _c(
                        "v-list-item-content",
                        { staticClass: "py-0" },
                        [
                          _c(
                            "v-list-item-subtitle",
                            { staticClass: "hour-range-filter__shift" },
                            [_vm._v(" " + _vm._s(item.header) + " ")]
                          ),
                        ],
                        1
                      ),
                    ]
                  : [
                      _c(
                        "v-list-item-content",
                        { staticClass: "hour-range-filter__hour" },
                        [_c("v-list-item-title", [_vm._v(_vm._s(item.label))])],
                        1
                      ),
                    ],
              ]
            },
          },
        ]),
      }),
      !_vm.loading && !_vm.hasOptions && !_vm.disabled
        ? _c(
            "div",
            { staticClass: "caption error--text mt-1" },
            [
              _c("v-icon", { attrs: { "x-small": "", color: "error" } }, [
                _vm._v("mdi-alert-circle-outline"),
              ]),
              _vm._v(" Sem horários cadastrados na grade institucional. "),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }